"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LatexParser = exports.DefaultParser = void 0;
var Utils_1 = require("./Utils");
function IrrationalStringToLatex(irrationalString) {
    if (Utils_1.StringIsSimpleIrrational(irrationalString)) {
        switch (irrationalString) {
            case "pi":
                return "\\pi";
            case "pi²":
                return "\\pi^2";
            case "φ":
                return "\\varphi";
            case "e":
                return "e";
            case "e²":
                return "e^2";
            case "√2":
                return "\\sqrt{2}";
            case "√3":
                return "\\sqrt{3}";
            case "√5":
                return "\\sqrt{5}";
            case "√7":
                return "\\sqrt{7}";
        }
    }
    return undefined;
}
var DefaultParser = function (frac) {
    var numerator = frac.numerator.join("*");
    if (frac.numerator.length > 1)
        numerator = "(" + numerator + ")";
    var denominator = frac.denominator.join("*");
    if (frac.denominator.length > 1)
        denominator = "(" + denominator + ")";
    return numerator + "/" + denominator;
};
exports.DefaultParser = DefaultParser;
function LatexFlattenInput(input) {
    var str = "";
    input.forEach(function (value) {
        if (typeof value === "number") {
            if (str !== "")
                str += "*";
            str += value;
            return;
        }
        var latex = IrrationalStringToLatex(value);
        if (latex !== undefined) {
            if (str !== "")
                str += "*";
            str += latex;
            return;
        }
    });
    return str;
}
var LatexParser = function (frac) {
    var numerator = LatexFlattenInput(frac.numerator);
    var denominator = LatexFlattenInput(frac.denominator);
    return "\\frac{" + numerator + "}{" + denominator + "}";
};
exports.LatexParser = LatexParser;
//
// console.log(
//   DefaultParser({
//     numerator: [3],
//     denominator: [4, "e²"],
//   })
// ) // (3*3)/(4)
//
// console.log(
//   LatexParser({
//     numerator: [3, 3],
//     denominator: [4, "e²"],
//   })
// ) // (3*3)/(4)
//# sourceMappingURL=OutputParsers.js.map